import React from 'react';

const Services = () => {
  return (
    <section id="services" className="services bg-light" style={{ padding: "6rem 0", position: "relative" }}>
      <div className="container text-center reveal">
        <h4 className="section-subtitle">Test Laboratuvarı</h4>
        <h2 className="section-title">Akredite <span className="highlight">Kaynak Testleri</span></h2>
        <p className="max-w-700 mx-auto mt-2">Sadece metallerinizi kesmiyor, ürettiğiniz kaynaklı imalatların kalitesini gelişmiş NDT ve tahribatlı yöntemlerle belgelendiriyoruz.</p>
      </div>

      <div className="container mt-4 reveal delay-1">
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "2rem" }}>
          
          <div className="product-card">
            <div className="card-glow"></div>
            <div className="product-icon" style={{ color: "var(--primary)" }}><i className="fa-solid fa-microscope"></i></div>
            <h4 style={{ fontSize: "1.25rem", marginBottom: "1rem" }}>Tahribatsız Muayene (NDT)</h4>
            <p style={{ color: "var(--text-muted)" }}>Ultrasonik (UT), Manyetik Parçacık (MT), Penetrant (PT) ve Radyografik (RT) testler ile kaynak hatalarını malzemeye zarar vermeden tespit ediyoruz.</p>
          </div>

          <div className="product-card">
            <div className="card-glow"></div>
            <div className="product-icon" style={{ color: "var(--primary)" }}><i className="fa-solid fa-hammer"></i></div>
            <h4 style={{ fontSize: "1.25rem", marginBottom: "1rem" }}>Tahribatlı Testler</h4>
            <p style={{ color: "var(--text-muted)" }}>Çekme kopma, eğme, çentik darbe ve sertlik testleri ile malzeme mukavemet parametrelerini endüstriyel standartlara dayandırıyoruz.</p>
          </div>

          <div className="product-card">
            <div className="card-glow"></div>
            <div className="product-icon" style={{ color: "var(--primary)" }}><i className="fa-solid fa-file-signature"></i></div>
            <h4 style={{ fontSize: "1.25rem", marginBottom: "1rem" }}>Kaynak Prosedürü Onayı (WPQR)</h4>
            <p style={{ color: "var(--text-muted)" }}>Firmanızın kaynak yöntem şartnamelerini (WPS) ilgili ISO standartlarına göre onaylıyor ve kaynakçı sertifikalandırmasını yürütüyoruz.</p>
          </div>

        </div>
      </div>
      
      {/* Visual Break */}
      <div className="container mt-4 reveal delay-2">
         <div style={{
            position: "relative",
            width: "100%",
            height: "400px",
            borderRadius: "var(--radius-xl)",
            overflow: "hidden",
            backgroundImage: "url('/assets/welding.png')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            alignItems: "flex-end",
            padding: "2rem"
         }}>
             <div style={{ background: "rgba(0,0,0,0.7)", padding: "1.5rem", borderRadius: "var(--radius-lg)", color: "white", backdropFilter: "blur(10px)" }}>
                 <h3 style={{ color: "white", marginBottom: "0.5rem" }}>Uzman Kalite Mühendisleri</h3>
                 <p style={{ color: "#d1d5db", margin: 0 }}>Entegre test laboratuvarımızda tüm imalat sürecinizi güvence altına alıyoruz.</p>
             </div>
         </div>
      </div>
    </section>
  );
};

export default Services;
